const cards = document.querySelectorAll('.employee-card-stack .employee-card');
const nextButton = document.querySelector('#emplpoyee-card-stack-next');
const prevButton = document.querySelector('#emplpoyee-card-stack-prev');
const buttonContainer = document.querySelector('.employee-card-stack-buttons-container');

if (cards.length > 2 && nextButton) {
	nextButton.addEventListener('click', showNext);
	prevButton.addEventListener('click', showPrev);
}

if (cards.length <= 2 && nextButton) {
	buttonContainer.classList.add('hidden');
}

function showNext() {
	let activeCards = findActive();
	let nextCard = activeCards[1] + 1;
	if ((nextCard) === cards.length) {
		
	} else if ((nextCard) === cards.length - 1) {
		prevButton.style.visibility = 'visible';
		nextButton.style.visibility = 'hidden';
		makeActive(nextCard);
		removeActive(activeCards[0]);
	} else {
		prevButton.style.visibility = 'visible';
		makeActive(nextCard);
		removeActive(activeCards[0]);
	}
}

function showPrev() {
	let activeCards = findActive();
	let nextCard = activeCards[0] - 1;
	if ((nextCard) === -1) {
		
	} else if ((nextCard) === 0 ) {
		prevButton.style.visibility = 'hidden';
		nextButton.style.visibility = 'visible';
		makeActive(nextCard);
		removeActive(activeCards[1]);
	} else {
		nextButton.style.visibility = 'visible';
		makeActive(nextCard);
		removeActive(activeCards[1]);
	}
}

function findActive() {
	let currentActive = [];
	cards.forEach((card, index) => {
		if (card.classList.contains('employee-card-active')) {
			currentActive.push(index);
		}
	});

	return currentActive;
}

function makeActive(index) {
	cards[index].classList.add('employee-card-active');
}

function removeActive(index) {
	cards[index].classList.remove('employee-card-active');
}